import { SelectItem } from "primeng/api";

enum Gender {
    Male = 1,
    Female,
    NotApplicable
}

const GenderMap: { [key: number]: string } = {};
GenderMap[Gender.Male] = "Male";
GenderMap[Gender.Female] = "Female";
GenderMap[Gender.NotApplicable] = "N/A";

const AllGenders = [Gender.Male, Gender.Female, Gender.NotApplicable];

const createOptions = () => AllGenders.map(mc => <SelectItem>{ label: GenderMap[mc], value: mc });

export { Gender, GenderMap, createOptions };
